import {type InputMenuState, type InputMenuAction, inputMenuActionType} from 'interfaces';

function inputMenuReducer(state: InputMenuState, action: InputMenuAction): InputMenuState {
  switch (action.type) {
    case inputMenuActionType.openInputMenu:
      return {
        ...state,
        method: action.method,
        form: action.form ? action.form : state.form,
        formData: action.formData ? action.formData : state.formData,
        persistent: action.persistent,
        popOver: {
          open: false,
        },
        onClose: action.onClose,
      };
    case inputMenuActionType.setFormData:
      return {
        ...state,
        method: action.method,
        form: action.form,
        formData: action.formData,
        persistent: action.persistent,
        popOver: action.popOver,
        onClose: action.onClose,
      };
    case inputMenuActionType.closeMenu:
      return {...state, form: undefined, method: undefined, formData: undefined, onClose: undefined};
    case inputMenuActionType.closePopOver:
      return {
        ...state,
        popOver: {
          open: false,
        },
      };
    case inputMenuActionType.openModalWindow:
      return {
        ...state,
        modalWindow: action.modalWindow,
      };
    case inputMenuActionType.closeModalWindow:
      return {
        ...state,
        modalWindow: undefined,
      };
    default:
      throw new Error(`Action ${action.type} does not exist.`);
  }
}

export default inputMenuReducer;
